import { stringify } from 'query-string';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, RouteProps } from 'react-router';
import { Route, withRouter } from 'react-router-dom';

import { Spinner } from '../components';
import { GeneralLink } from '../models/Routes';
import { userActions, userSelectors } from '../redux';
import { LanguageService } from '../services';
import { LANGAUGE_KEY } from '../services/LanguageService';
import { UserService } from '../services/UserService';

interface Props extends RouteProps {
  component: FC;
  pending?: boolean;
}

const AuthorizedRoute: FC<Props & RouteComponentProps> = ({ component: Component, history, location, ...otherProps }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(userSelectors.isLoading);
  const userInfo = useSelector(userSelectors.getUserInfo);
  const loginError = useSelector(userSelectors.loginError);

  useEffect(() => {
    if (userInfo) {
      const defaultLanguage =
        localStorage.getItem(LANGAUGE_KEY) ??
        userInfo?.store?.defaultLanguage?.code ??
        userInfo.languages.find(({ code }) => navigator.language.includes(code))?.code;
      LanguageService.setLanguage(defaultLanguage ?? userInfo.languages[0].code);
    } else dispatch(userActions.getUserInfo());
  }, [userInfo]);

  useEffect(() => {
    if (loginError) {
      history.push(GeneralLink.ERROR + '?' + stringify({ message: 'errorLoginFailed' }));
      return;
    }
    if (!userInfo && !isLoading) {
      // User is not logged in, redirect to ikea login with active directory
      UserService.login(location);
    }

    // Enable this line for fake login
    // dispatch(loginActions.fakeLogin());
  }, [isLoading, userInfo, loginError]);

  return (
    <Route
      {...otherProps}
      render={() => {
        if (isLoading || !userInfo) {
          return (
            <div className='center-content'>
              <Spinner size='large' />
            </div>
          );
        }
        return <Component {...otherProps} />;
      }}
    />
  );
};

export default withRouter(AuthorizedRoute);
